import Animations from '../lib/animations';

export default class AboutComponent {
  static initAll() {
    Animations.init({
      // нужно указывать размерность для всех изменяющихся значений `from`
      // для цветов rgb(a)
      'cloud-1': {
        from: {
          transform: 'translate3d(0, 0, 0)'
        },
        to: {
          transform: 'translate3d(0, -50%, 0)'
        },
        speed: 1,
        inverted: true
      },
      ship: {
        from: {
          transform: 'translate3d(7%, 3.5%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 1
      },
      'cloud-2': {
        from: {
          transform: 'translate3d(0, 50%, 0)'
        },
        to: {
          transform: 'translate3d(0, -50%, 0)'
        },
        speed: 0.5
      },
      function: {
        from: {
          transform: 'translate3d(0, 20%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 2
      },
      counter: {
        from: {
          opacity: 0
        },
        to: {
          opacity: 1
        },
        speed: 2
      },
      'cloud-3': {
        from: {
          transform: 'translate3d(30%, 0, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 0.5
      },
      'cloud-4': {
        from: {
          transform: 'translate3d(0, 20%, 0)'
        },
        to: {
          transform: 'translate3d(0, -30%, 0)'
        },
        speed: 0.5
      },
      gondola: {
        from: {
          transform: 'translate3d(-50%, 0%, 0)'
        },
        to: {
          transform: 'translate3d(-100%, 8%, 0)'
        },
        speed: 1
      },
      submarine: {
        from: {
          transform: 'translate3d(-3%, 3.5%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 1
      },
      diver: {
        from: {
          transform: 'translate3d(-5%, -8%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 1
      },
      airship: {
        from: {
          transform: 'translate3d(-8%, 3%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 1
      },
      'cloud-5': {
        from: {
          transform: 'translate3d(20%, 0, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 0.5
      }
    });
  }
}
